import { render } from "./modelconfig.vue?vue&type=template&id=e508d6f4&scoped=true"
import script from "./modelconfig.vue?vue&type=script&lang=js"
export * from "./modelconfig.vue?vue&type=script&lang=js"

import "./modelconfig.vue?vue&type=style&index=0&id=e508d6f4&scoped=true&lang=css"
import "./modelconfig.vue?vue&type=style&index=1&id=e508d6f4&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e508d6f4"]])

export default __exports__